import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { HStack, VStack } from '@/components/Layout';
import AddStepperCompleteDialog from '@/components/Stepper/AddStepperCompleteDialog';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { useGetCategoryFieldAccessCategoryTrees } from '@/routes/_staff/settings/permission-and-roles/-query/category-tree';
import { selectedNodeIdsToSettings } from '@/routes/_staff/settings/permission-and-roles/-utils/settings-converter';
import AddStepperNavigation from '../-components/AddStepperNavigation';
import AddStepperPanelProgress from '../-components/AddStepperPanelProgress';
import AddStepperStepTitleCard from '../-components/AddStepperStepTitleCard';
import BasicForm from '../-components/BasicForm';
import SetCategoryPermission from '../-components/SetCategoryPermission';
import { FORM_HASH } from '../-constants';
import useBasicForm from '../-hooks/useBasicForm';
import useCategoryPermissionForm from '../-hooks/useCategoryPermissionForm';
import useHash from '../-hooks/useHash';
import useScopeSteps from '../-hooks/useScopeSteps';
import { useCreateCategoryFieldAccessPermission, useGetCategoryFieldAccessPermissions } from '../-query';
export const Route = createFileRoute('/_staff/settings/permission-and-roles/_form/category-permissions/new/')({
  component: RouteComponent
});
const BASE_LINK = '/settings/permission-and-roles/category-permissions/new';
function RouteComponent() {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.settings.permissionAndRoles.createCategoryPermission'
  });
  const {
    hash
  } = useHash();
  const {
    scopeSteps
  } = useScopeSteps();
  const {
    data: permissionsData
  } = useGetCategoryFieldAccessPermissions();
  const existingNames = permissionsData?.items.map(r => r.permissionName) ?? [];
  const {
    basicFormState,
    handleChange,
    isDuplicateName
  } = useBasicForm({
    existingNames
  });
  const {
    selectedNodeIds,
    setSelectedNodeIds
  } = useCategoryPermissionForm({});
  const [isComplete, setIsComplete] = useState(false);
  const createMutation = useCreateCategoryFieldAccessPermission();
  const {
    data: treeData
  } = useGetCategoryFieldAccessCategoryTrees();
  const handleComplete = async () => {
    if (!treeData?.items) return;
    const settings = selectedNodeIdsToSettings(selectedNodeIds, treeData.items);
    await createMutation.mutateAsync({
      permissionName: basicFormState.name,
      intendedUse: basicFormState.description || undefined,
      settings
    });
    setIsComplete(true);
  };
  const activeScopeStep = scopeSteps.find(s => s.hash === hash);
  return <HStack className="gap-9 p-10 h-[calc(100vh-64px)]">
      <AddStepperNavigation baseLink={BASE_LINK} currentHash={hash} isEdit={false} />

      <VStack className="gap-6 w-full flex-1 min-h-0">
        <AddStepperStepTitleCard hash={hash} />

        {hash === FORM_HASH && <BasicForm basicFormState={basicFormState} handleChange={handleChange} isDuplicateName={isDuplicateName} />}

        {activeScopeStep && <SetCategoryPermission scopeCode={activeScopeStep.scopeCode} selectedNodeIds={selectedNodeIds} onChangeSelectedNodeIds={setSelectedNodeIds} />}

        <AddStepperPanelProgress baseLink={BASE_LINK} currentHash={hash} basicFormState={basicFormState} selectedNodeIds={selectedNodeIds} onComplete={handleComplete} isEdit={false} isDuplicateName={isDuplicateName} />

        {isComplete && <AddStepperCompleteDialog completeMessage={t('addStepperCompleteDialog.create.completeMessage')} completeLinkButtonText={t('addStepperCompleteDialog.create.completeLinkButtonText')} completeLinkUrl="/settings/permission-and-roles/category-permissions" />}
      </VStack>
    </HStack>;
}